
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const deleteTemplateApi = createAsyncThunk(
  "deleteTemplate",
  async ({
    rowId
}) => {
      console.log("rowId: in delete slice ", rowId);
    const response = await axiosInstance.delete(`/deleteTemplate/${rowId}`);
    return response.data;
  }
);

const deleteTemplateSlice = createSlice({
  name: "deleteTemplate",
initialState: {
    deleteTemplate: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteTemplateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTemplateApi.fulfilled, (state, action) => {
        state.deleteTemplate = action.payload;
        state.loading = false;
      })
      .addCase(deleteTemplateApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default deleteTemplateSlice.reducer;
